import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_audit_log_field_types_displaying_values_default_key = _resolveComponent("audit-log-field-types-displaying-values-default-key")!
  const _component_audit_log_field_types_displaying_values_index = _resolveComponent("audit-log-field-types-displaying-values-index")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_audit_log_field_types_displaying_values_default_key, {
      keyValue: _ctx.field.key,
      "key-mapper": _ctx.keyMapper
    }, null, 8, ["keyValue", "key-mapper"]),
    _createVNode(_component_audit_log_field_types_displaying_values_index, {
      value: _ctx.field.value
    }, null, 8, ["value"])
  ]))
}